import 'react-datepicker/dist/react-datepicker.css';

import { getSelectedLanguage } from '@config/i18n';
import { enUS, nl } from 'date-fns/locale';
import ReactDatePicker, { type DatePickerProps } from 'react-datepicker';

const resolveLocale = () => {
  if (getSelectedLanguage() === 'nl') {
    return nl;
  }

  return enUS;
};

/**
 * Shared wrapper around react-datepicker.
 *
 * Owns the vendor stylesheet import so the calendar styles travel with the
 * component into whichever bundle chunk uses it. Import this instead of
 * `react-datepicker` directly - a direct import renders an unstyled calendar
 * on any route that does not already pull in this module.
 *
 * Applies the shared locale and popper placement. `dateFormat` stays with the
 * call site because the formats differ per feature.
 *
 * The vendor props are a union discriminated on `selectsRange` and
 * `selectsMultiple`, so this wrapper cannot default them. A call site that
 * passes an inline `onChange` arrow must set both to `false`, otherwise the
 * `date` parameter has no contextual type.
 */
export const DatePicker = (props: DatePickerProps) => {
  return (
    <ReactDatePicker
      locale={resolveLocale()}
      popperPlacement='top-end'
      {...props}
    />
  );
};

export default DatePicker;
